import { registerSchema } from "yage/components/ComponentRegistry";
import { Component, Schema } from "yage/decorators/type";

@Component("TurretType")
export class TurretTypeSchema extends Schema {}

registerSchema(TurretTypeSchema);
